import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Orgao } from "./orgao.model";
import { apiName } from "./data.service";

@Injectable()
export class OrgaoApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Orgao, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Orgao, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    this._restService.onGetPostCustom(apiName + '/populado', {}, done);//busca orgaos populado com areas
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":[{"responsavel":["pessoa"]},{"endereco":[{"cidade":"estado"},"tipoLogradouro"]},"tipoOrgao"]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/shared/orgao-api.service.ts
 **/